import React from 'react'
import {UnderConstruction} from '../../UnderConstruction/UnderConstruction';
export const Care = () => {
  return (
    <UnderConstruction/>
  )
}
